/**
 * Build SSE URL for ask-google-analytics-question endpoint
 * Includes authentication in URL (EventSource doesn't support headers)
 * @param {Object} params - Query parameters
 * @param {Object} authData - Authentication data { token, email, tokenType }
 * @returns {string} - Complete SSE URL with stream=true and auth token
 */
export const buildSSEUrl = (params, authData = {}) => {
    const {
        question,
        property_id = '',
        meta_id = '',
        google_ads_id = '',
        shopify_id = '',
        chat_id = '',
        custom_bq_tool = '',
        youtube_id = '',
        youtube_channel_id = '',
        workspace_id = ''
    } = params;

    const { token, email, tokenType = 'Bearer' } = authData;

    const baseUrl = process.env.REACT_APP_BASE_URL;
    // const baseUrl = "https://oogwai.gaggle.online/";

    const endpoint = `${process.env.REACT_APP_BASE_URL}api/v1/ask-google-anaytics-question-demo`;

    console.log('🔧 [buildSSEUrl] Base URL:', baseUrl);
    console.log('🔧 [buildSSEUrl] Endpoint:', endpoint);
    console.log('🔧 [buildSSEUrl] Has token:', !!token);

    // Build query params object
    const queryParamsObj = {
        question,
        property_id,
        meta_id,
        google_ads_id,
        shopify_id,
        chat_id,
        custom_bq_tool,
        youtube_id,
        youtube_channel_id,
        workspace_id,
        stream: 'true' // Enable SSE streaming
    };

    // Omit empty params to reduce backend ambiguity
    Object.keys(queryParamsObj).forEach((key) => {
        if (queryParamsObj[key] === '' || queryParamsObj[key] === undefined || queryParamsObj[key] === null) {
            delete queryParamsObj[key];
        }
    });

    // Add authentication to URL (EventSource doesn't support headers)
    if (token) {
        queryParamsObj.token = token;
        queryParamsObj.token_type = tokenType;
    }

    // Add shadow user email if present
    if (email) {
        queryParamsObj.email = email;
    }

    // Build query string
    const queryParams = new URLSearchParams(queryParamsObj);

    const fullUrl = `${endpoint}?${queryParams.toString()}`;
    console.log('🔧 [buildSSEUrl] Full URL (token hidden):', fullUrl.replace(/token=[^&]+/, 'token=***'));

    return fullUrl;
};

/**
 * Get workspace ID from localStorage
 * @returns {string} - Workspace ID
 */
export const getWorkspaceId = () => {
    return localStorage.getItem("workspace_id") || "Demo";
};

/**
 * Get authentication token for SSE
 * @returns {Promise<Object>} - { token, email, tokenType }
 */
export const getAuthToken = async () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const emailShop = urlParams.get("email");
        const getShopifyUser = localStorage.getItem("oogw.ai_user");
        const tokenType = localStorage.getItem("oogw.ai_user_type") || "Bearer";

        // Shopify authentication
        if (emailShop || tokenType === "Shopify") {
            return {
                token: emailShop || getShopifyUser,
                tokenType: tokenType,
                email: localStorage.getItem("oogw.ai_shadow_user_email")
            };
        }

        // Firebase authentication
        const { getSession } = await import('../services/auth');
        const session = await getSession();
        const token = session?.idToken?.jwtToken;
        const shadowEmail = localStorage.getItem("oogw.ai_shadow_user_email");

        return {
            token: token,
            tokenType: tokenType,
            email: shadowEmail && shadowEmail !== 'undefined' ? shadowEmail : null
        };
    } catch (error) {
        console.error('[getAuthToken] Error:', error);
        throw new Error("Failed to get authentication token");
    }
};
